function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 14",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: "0"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8 2.493l5.648 9.757H2.353L8 2.493zM1.055 11.5a1.5 1.5 0 001.298 2.25h11.295a1.5 1.5 0 001.297-2.25L9.298 1.743a1.5 1.5 0 00-2.595 0L1.055 11.5zM7.25 6.25v1.5c0 .413.338.75.75.75.413 0 .75-.337.75-.75v-1.5A.752.752 0 008 5.5a.752.752 0 00-.75.75zm0 3.75h1.5v1.5h-1.5V10z"
}));